(function () {
  const LOADED_CLASS = 'hero-showcase--loaded';
  const WORD_CLASS = 'hero-showcase__animated-text';

  function wrapWords(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    let wordIndex = Number(element.dataset.wordOffset || 0);

    textNodes.forEach((node) => {
      const parts = node.textContent.split(/(\s+)/);
      const fragment = document.createDocumentFragment();

      parts.forEach((part) => {
        if (!part) return;

        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }

        const span = document.createElement('span');
        span.className = WORD_CLASS;
        span.style.setProperty('--word-index', wordIndex);
        span.textContent = part;
        fragment.appendChild(span);
        wordIndex += 1;
      });

      node.parentNode.replaceChild(fragment, node);
    });

    element.dataset.wordOffset = wordIndex;
  }

  function initHeroShowcase(root = document) {
    const sections = root.querySelectorAll('.hero-showcase:not([data-hero-animated])');

    sections.forEach((section) => {
      section.dataset.heroAnimated = 'true';

      const heading = section.querySelector('.hero-showcase__heading');
      if (heading) wrapWords(heading);

      const text = section.querySelector('.hero-showcase__text');
      if (text) wrapWords(text);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.remove('hero-showcase--pending');
        section.classList.add(LOADED_CLASS);
        return;
      }

      section.classList.remove('hero-showcase--pending');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => section.classList.add(LOADED_CLASS));
      });
    });
  }

  function boot() {
    initHeroShowcase();
  }

  boot();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initHeroShowcase(event.target));
  }

  setTimeout(() => {
    document.querySelectorAll('.hero-showcase--pending').forEach((section) => {
      section.classList.remove('hero-showcase--pending');
      section.classList.add(LOADED_CLASS);
    });
  }, 3000);
})();
